const styles = {
  root: {},
  expandButton: {
    '& svg': {
      fill: (theme) => `${theme.palette.text.thirdDark}`,
    },
  },
}
export default styles
